import { LocalAudioTrack, LocalVideoTrack } from 'twilio-video';

// eslint-disable-next-line import/prefer-default-export
export function localTrackToMediaStream(track: LocalAudioTrack | LocalVideoTrack) {
    return new MediaStream([track.mediaStreamTrack]);
}
